<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" epub:type="foreword" id="_idContainer009">
<h1 class="Front-Title" id="_idParaDest-2"><a id="_idTextAnchor001"></a>Foreword</h1>
<p class="Normal"><span class="lede _idGenCharOverride-2">Belinda Smith-Sullivan </span>has become one of the South’s great recipe developers and cookbook authors on the strength of her exceptionally fine sense of balance and her prodigious energy, turning the ripe orchard peach into a whole rhapsody on the fruit entitled <em class="Emphasis _idGenCharOverride-1">Just Peachy</em>, which incorporates ancient farmstead traditions and modern culinary practice in 70 delicious and finely-tuned recipes.</p>
<p class="Normal">She is—no surprise—the perfect person to attack the weekend’s great comfort-food meal and find both fresh ideas and wonderful heirlooms worth celebrating. We hope you will be inspired as we are by Smith-Sullivan’s recipes and words and by Susan Barnson Hayward’s ravishing photos in <em class="Emphasis _idGenCharOverride-1">Let’s Brunch</em>!</p>
<p class="Normal ParaOverride-2">— Matt Lee and Ted Lee, authors of <br/><em class="Emphasis _idGenCharOverride-1">The Lee Bros. Charleston Kitchen</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Lets-Brunch-Interiors_D-3.vue?79ec6df4